<template>
    <div class="saas-page engagement-page linear-command-page">
        <div class="saas-hero card-saas engagement-page__hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('query.query') }}</span>
                </p>
                <h1 class="saas-hero__title">{{trans('query.query')}}</h1>
            </div>
            <div class="engagement-page__actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders"></admin-icon> <span>{{trans('general.filter')}}</span>
                </button>
            </div>
        </div>

        <div class="engagement-command-grid">
            <section class="engagement-command-card">
                <span>{{ trans('query.query') }}</span>
                <strong>{{ queries.total || 0 }}</strong>
                <p>{{ queries.total ? trans('general.total_result_found',{'count' : queries.total}) : trans('general.no_result_found') }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('query.status') }}</span>
                <strong>{{ filterQueryForm.status || trans('general.select_one') }}</strong>
                <p>{{ trans('query.keyword') }}: {{ filterQueryForm.keyword || '-' }}</p>
            </section>
            <section class="engagement-command-card engagement-command-card--muted">
                <span>{{ trans('general.sort_by') }}</span>
                <strong>{{ filterQueryForm.sort_by }}</strong>
                <p>{{ trans('general.order') }}: {{ filterQueryForm.order }}</p>
            </section>
        </div>
        
        <transition name="fade">
            <div class="card-saas engagement-filter-card" v-if="showFilterPanel">
                <div class="card-body">
                    <h4 class="card-saas__title">{{trans('general.filter')}}</h4>
                    <div class="row">
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.keyword')}}</label>
                                <input class="form-control" name="keyword" v-model="filterQueryForm.keyword">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.first_name')}}</label>
                                <input class="form-control" name="first_name" v-model="filterQueryForm.first_name">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.last_name')}}</label>
                                <input class="form-control" name="last_name" v-model="filterQueryForm.last_name">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.email')}}</label>
                                <input class="form-control" name="email" v-model="filterQueryForm.email">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.phone')}}</label>
                                <input class="form-control" name="phone" v-model="filterQueryForm.phone">
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('query.status')}}</label>
                                <select name="status" class="form-control" v-model="filterQueryForm.status">
                                    <option value="">{{trans('general.select_one')}}</option>
                                    <option value="replied">{{trans('query.replied')}}</option>
                                    <option value="unanswered">{{trans('query.unanswered')}}</option>
                                    <option value="under_process">{{trans('query.under_process')}}</option>
                                    <option value="awaiting_response">{{trans('query.awaiting_response')}}</option>
                                    <option value="resolved">{{trans('query.resolved')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <date-range-picker :start-date.sync="filterQueryForm.start_date" :end-date.sync="filterQueryForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.sort_by')}}</label>
                                <select name="order" class="form-control" v-model="filterQueryForm.sort_by">
                                    <option value="first_name">{{trans('query.first_name')}}</option>
                                    <option value="last_name">{{trans('query.last_name')}}</option>
                                    <option value="email">{{trans('query.email')}}</option>
                                    <option value="phone">{{trans('query.phone')}}</option>
                                    <option value="subject">{{trans('query.subject')}}</option>
                                    <option value="created_at">{{trans('query.created_at')}}</option>
                                    <option value="status">{{trans('query.status')}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 col-sm-3">
                            <div class="form-group">
                                <label for="">{{trans('general.order')}}</label>
                                <select name="order" class="form-control" v-model="filterQueryForm.order">
                                    <option value="asc">{{trans('general.ascending')}}</option>
                                    <option value="desc">{{trans('general.descending')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        
        <div class="admin-list-table-card mt-3" v-if="hasPermission('list-query') && queries.total">
            <div class="table-responsive">
                <table class="table admin-data-table mb-0">
                    <thead>
                        <tr>
                            <sortable-th field="first_name" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.first_name')}}</sortable-th>
                            <sortable-th field="last_name" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.last_name')}}</sortable-th>
                            <sortable-th field="status" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.status')}}</sortable-th>
                            <sortable-th field="email" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.email')}}</sortable-th>
                            <sortable-th field="phone" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.phone')}}</sortable-th>
                            <sortable-th field="subject" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.subject')}}</sortable-th>
                            <sortable-th field="created_at" :sort-by="filterQueryForm.sort_by" :order="filterQueryForm.order" @sort="sortList">{{trans('query.created_at')}}</sortable-th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="query in queries.data" :key="query.id">
                            <td>
                                <span class="engagement-table__primary" v-text="query.first_name"></span>
                                <span class="engagement-table__meta">#{{ query.id }}</span>
                            </td>
                            <td><span class="engagement-table__primary" v-text="query.last_name"></span></td>
                            <td v-html="getStatus(query)"></td>
                            <td><span class="engagement-table__muted" v-text="query.email"></span></td>
                            <td><span class="engagement-table__muted" v-text="query.phone"></span></td>
                            <td><span class="engagement-table__subject" v-text="query.subject"></span></td>
                            <td><span class="engagement-table__muted">{{query.created_at | moment }}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button @click="openQueryDetail(query)">
                                        <admin-icon name="eye"></admin-icon> {{ trans('query.view') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-if="hasPermission('delete-query')"
                                        v-confirm="{ok: confirmDelete(query)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterQueryForm.page_length" :records="queries" @updateRecords="getQueries" @change.native="getQueries"></pagination-record>
            </div>
        </div>

        <div class="modal fade query-detail engagement-query-modal admin-modal-pro sip-view-modal" tabindex="-1" role="dialog" aria-labelledby="queryDetail" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content admin-modal-pro__content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="queryDetail">{{ query.subject || trans('query.query') }}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body" v-if="query">
                        <p class="sip-view-status__meta mb-3" v-if="query.created_at">{{query.created_at | moment}}</p>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <dl class="sip-view-dl">
                                    <div class="sip-view-dl__row">
                                        <dt>{{trans('query.name')}}</dt>
                                        <dd>{{query.first_name+' '+query.last_name}}</dd>
                                    </div>
                                    <div class="sip-view-dl__row">
                                        <dt>{{trans('query.email')}}</dt>
                                        <dd>{{query.email}}</dd>
                                    </div>
                                    <div class="sip-view-dl__row">
                                        <dt>{{trans('query.phone')}}</dt>
                                        <dd>{{query.phone}}</dd>
                                    </div>
                                    <div class="sip-view-dl__row">
                                        <dt>{{trans('query.ip')}}</dt>
                                        <dd>{{query.ip}}</dd>
                                    </div>
                                    <div class="sip-view-dl__row">
                                        <dt>{{trans('query.user_agent')}}</dt>
                                        <dd>{{query.user_agent}}</dd>
                                    </div>
                                </dl>
                            </div>
                            <div class="col-12 col-sm-6" v-if="hasPermission('edit-query')">
                                <h4 class="sip-view-section-title">{{trans('query.update_status')}}</h4>
                                <div class="form-group">
                                    <div class="admin-radio">
                                        <input type="radio" value="unanswered" id="status_unanswered" v-model="status" :checked="query.status === 'unanswered'">
                                        <label for="status_unanswered"> {{trans('query.unanswered')}} </label>
                                    </div>
                                    <div class="admin-radio">
                                        <input type="radio" value="replied" id="status_replied" v-model="status" :checked="query.status === 'replied'">
                                        <label for="status_replied"> {{trans('query.replied')}} </label>
                                    </div>
                                    <div class="admin-radio">
                                        <input type="radio" value="under_process" id="status_under_process" v-model="status" :checked="query.status === 'under_process'">
                                        <label for="status_under_process"> {{trans('query.under_process')}} </label>
                                    </div>
                                        <div class="admin-radio">
                                    <input type="radio" value="awaiting_response" id="status_awaiting_response" v-model="status" :checked="query.status === 'awaiting_response'">
                                        <label for="status_awaiting_response"> {{trans('query.awaiting_response')}} </label>
                                    </div>
                                        <div class="admin-radio">
                                    <input type="radio" value="resolved" id="status_resolved" v-model="status" :checked="query.status === 'resolved'">
                                        <label for="status_resolved"> {{trans('query.resolved')}} </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid" @click="updateStatus">{{trans('general.save')}}</button>
                                </div>
                            </div>
                        </div>
                        <div class="sip-view-rich sip-view-thread__body" v-html="query.body"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" data-dismiss="modal">{{trans('general.close')}}</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="admin-list-table-card admin-empty-state mt-3" v-if="!queries.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="chat"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
            </div>
        </div>
    </div>
</template>
<script>
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components: {dateRangePicker},
        data(){
            return {
                queries: {
                    total: 0,
                    data: []
                },
                filterQueryForm: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    keyword: '',
                    status: '',
                    start_date: '',
                    end_date: '',
                    order: 'desc',
                    sort_by: 'created_at',
                    page_length: helper.getConfig('page_length')
                },
                query: {},
                showFilterPanel: false,
                status: '',
                id: ''
            };
        },
        mounted(){
            this.getQueries();
        },
        methods: {
            getQueries(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterQueryForm);
                axios.get('/api/query?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.queries = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            fetchQuery(query){
                axios.get('/api/query/'+query.id)
                    .then(response => response.data)
                    .then(response => {
                        this.query = response;
                        this.status = response.status;
                        this.id = response.id;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            openQueryDetail(query){
                axios.get('/api/query/'+query.id)
                    .then(response => response.data)
                    .then(response => {
                        this.query = response;
                        this.status = response.status;
                        this.id = response.id;
                        this.$nextTick(() => {
                            if (window.$) {
                                window.$('.query-detail').modal('show');
                            }
                        });
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(query){
                return dialog => this.deleteQuery(query);
            },
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            deleteQuery(query){
                axios.delete('/api/query/'+query.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getQueries();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getStatus(query){
                if(query.status === 'unanswered')
                    return '<span class="admin-status-badge admin-status-badge--danger">'+i18n.query.unanswered+'</span>';
                else if(query.status === 'under_process')
                    return '<span class="admin-status-badge admin-status-badge--info">'+i18n.query.under_process+'</span>';
                else if(query.status === 'replied')
                    return '<span class="admin-status-badge admin-status-badge--success">'+i18n.query.replied+'</span>';
                else if(query.status === 'awaiting_response')
                    return '<span class="admin-status-badge admin-status-badge--warning">'+i18n.query.awaiting_response+'</span>';
                else if(query.status === 'resolved')
                    return '<span class="admin-status-badge admin-status-badge--success">'+i18n.query.resolved+'</span>';
            },
            nl2br(str){
                return helper.nl2br(str);
            },
            updateStatus(){
                axios.patch('/api/query/'+this.id,{
                    id: this.id,
                    status: this.status
                }).then(response => response.data)
                .then(response => {
                    this.getQueries();
                    toastr.success(response.message);
                }).catch(error => {
                    helper.showDataErrorMsg(error);
                });
            },
            sortList(field){
                if (this.filterQueryForm.sort_by === field) {
                    this.filterQueryForm.order = this.filterQueryForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterQueryForm.sort_by = field;
                    this.filterQueryForm.order = 'asc';
                }
            }
        },
        filters: {
          moment(date) {
            return helper.formatDateTime(date);
          }
        },
        watch: {
            filterQueryForm: {
                handler(val){
                    this.getQueries();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
.linear-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7ef;
    --linear-muted: #687083;
    --linear-ink: #111318;
}

.engagement-page__hero {
    align-items: center;
    border-color: rgba(98, 92, 246, 0.14);
    background:
        radial-gradient(circle at top right, rgba(98, 92, 246, 0.13), transparent 28rem),
        rgba(255, 255, 255, 0.94);
}

.engagement-page__actions {
    display: flex;
    justify-content: flex-end;
}

.engagement-command-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.9rem;
    margin: 1rem 0;
}

.engagement-command-card {
    min-height: 112px;
    padding: 1rem;
    border: 1px solid var(--linear-line);
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 16px 42px rgba(31, 35, 48, 0.055);
}

.engagement-command-card--muted {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%);
}

.engagement-command-card span {
    color: var(--linear-accent);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.engagement-command-card strong {
    display: block;
    margin-top: 0.45rem;
    color: var(--linear-ink);
    font-size: 1.45rem;
    font-weight: 800;
    letter-spacing: -0.04em;
}

.engagement-command-card p {
    margin: 0.35rem 0 0;
    color: var(--linear-muted);
    line-height: 1.45;
}

.engagement-filter-card {
    padding: 0;
    overflow: hidden;
}

.engagement-filter-card .card-body {
    padding: 1rem 1.15rem;
}

.engagement-table__primary,
.engagement-table__subject {
    color: #0f172a;
    font-weight: 700;
}

.engagement-table__meta {
    display: block;
    margin-top: 0.15rem;
    color: #94a3b8;
    font-size: 0.75rem;
    font-weight: 700;
}

.engagement-table__muted {
    color: #64748b;
}

.engagement-query-modal__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #f8f9ff 100%);
}

.engagement-query-modal__head h4 {
    margin: 0;
    color: #0f172a;
    font-weight: 700;
}

.engagement-query-modal__head span {
    color: #64748b;
    font-size: 0.8125rem;
    white-space: nowrap;
}

.engagement-query-modal__section-title {
    color: #0f172a;
    font-size: 0.95rem;
    font-weight: 700;
}

.engagement-query-modal__body {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #ffffff;
    color: #334155;
}

@media (max-width: 575.98px) {
    .engagement-page__hero,
    .engagement-query-modal__head {
        align-items: flex-start;
    }

    .engagement-page__actions {
        justify-content: flex-start;
        width: 100%;
    }

    .engagement-query-modal__head {
        flex-direction: column;
    }
}

@media (max-width: 991.98px) {
    .engagement-command-grid {
        grid-template-columns: 1fr;
    }
}
</style>
